<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Add Device</h2>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <AddDeviceForm :device="device"></AddDeviceForm>
      </div>
      <div class="col-4" v-if="hasExtension">
        <CurrentExtensions :default_type="'device'"></CurrentExtensions>
      </div>
    </div>
  </div>
</template>

<script>
import AddDeviceForm from '../../components/Device/AddDeviceForm.vue'
import CurrentExtensions from '../../components/CurrentExtensions'
import { DEVICE_TYPE, DEVICE_SIP_TYPE } from '../../assets/js/resource-types'

export default {
  components: { AddDeviceForm, CurrentExtensions },
  data() {
    return {
      device: {
        device_id: 0,
        name: '',
        password: '',
        device_type_id: DEVICE_TYPE.RTP,
        device_sip_type_id: DEVICE_SIP_TYPE.Generic,
        device_subtype_id: null,
        intercom_external_sip_id: '0',
        ip: '',
        camera_ip: '',
        port: '4444',
        extension: 0,
        enabled: 1,
        voip: 0,
        device_zones: [],
        device_attributes: []
      }
    }
  },
  computed: {
    hasExtension() {
      return this.device.device_type_id === DEVICE_TYPE.SIP 
        || this.device.device_type_id === DEVICE_TYPE.G2IPSpeaker
        || this.device.device_type_id === DEVICE_TYPE.G2Link
    }
  }
}
</script>

<style scoped>

</style>
